import React, { useCallback, useEffect, useState, useContext, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getCustomerInfo } from '@kfc-global/react-shared/redux/Actions/OrderservAction';
import {
  fetchItemDetailsAction,
  addItemToFavouriteAction,
  addItemToUnFavouriteAction,
} from '@kfc-global/react-shared/redux/Actions/MenuAction';
import {
  showCustomizationModalAction,
  addItemToCartAction,
  setUserLastActiveTime,
  resetBasketAction,
} from '@kfc-global/react-shared/redux/Actions/CartAction';
import { toast } from 'react-toastify';
import { localisationStartAnalytics } from 'common/utilities/analyticsUtils';
import tickWhiteToast from '../../../styles/staticAssets/images/tickWhiteToast.svg';
import ImageComponent from 'atoms/Image';
import { deleteFavOrder, addFavOrder } from '@kfc-global/react-shared/redux/Actions/OrderHistoryAction';
import {
  isEmptyObject,
  isEmptyEvery,
  getDispositionTypeOnAPIFormat,
  toastifyFnWithImage,
  getValueOrDefaultAlternativeObject,
  getValueOrEmptyString,
  getEmptyObjectforNull,
  getValueOrDefaultObject,
  getAndCheckIfOneTrue,
} from 'common/utilities/utils';
import { UserOrderContext } from 'context/context';
import { getCurrentDateTimeInUnix, dateIsBetween, getFormatFromUnix } from 'common/utilities/dayJsUtils';
import OrderDetailSection from './OrderDetailSection';
import OccassionItemsComponent from './OccassionItemsComponent';
import { ButtonComp } from 'atoms/Buttons';
import ReorderIcon from 'styles/staticAssets/images/Reorder.svg';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import ORDRE_HISTORY from 'organisms/AccountPage/Constants/Constants';
import ProductListingModalOptions from 'organisms/ProductListingModalOptions/Container/ProductListingModalOptionsComponent';
import EditOccasionModalComponent from './EditOccasionModalComponent';
import FavouriteMenuComponent from './FavouriteMenuComponent';
import ORDER_HISTORY from '../Constants/Constants';
import SingleArrowback from '../../../styles/staticAssets/images/SingleArrowback.svg';
import { addFavouriteItemToCart } from './../accountPageUtils';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import UserLocalization from 'organisms/MenusPLP/Presentation/UserLocalization';
import CartNotificationSuccessImage from 'styles/staticAssets/images/cart-notification-success.png';
import { ChannelManager } from 'common/manager';
import { getPostOrderAccepted } from '@kfc-global/react-shared/redux/Actions/PostOrderAction';
import { getReorderStoreStatus } from '@kfc-global/react-shared/redux/Actions/ReorderAction';
import { first, get } from 'lodash';
import ReorderComponent from 'organisms/ReorderComponent/Container/ReorderComponent';
import { ACCOUNT_FAVORDERS } from 'organisms/ReorderComponent/Constants/ReorderConstants';
import { CURRENT_FAV_MENU, ANALYTICS_SHARED_CONSTANTS, priceFixed_value } from 'common/constants/SharedConstants';
import AuthManager from '@kfc-global/react-shared/auth/AuthManager';
import { ViewFavMenu } from './AccountAnalytics';
const fetchCustomerInfo = (tenantId, customerId, phoneNumber, dispatch) => {
  if (tenantId) {
    const payload = {
      customerId,
      tenantId,
      phoneNumber,
      updateUserData: true,
    };
    dispatch(getCustomerInfo(payload));
  }
};
export const setViewFavOrderMenuAnalyticsData = (favItem, productMapById, currencyConversionFactor) => {
  const favItemDetails = favItem?.items ? favItem.items : favItem;
  const { ACCOUNT_FAV_PAGE } = ORDER_HISTORY;
  const itemsArray = [];
  favItemDetails?.forEach((i, idx) => {
    const price = favItem?.items
      ? getAndCheckIfOneTrue(Number((i?.price / currencyConversionFactor).toFixed(priceFixed_value)), 0)
      : getAndCheckIfOneTrue(i?.price, 0);
    const discountTotal = favItem?.items
      ? getAndCheckIfOneTrue(favItem?.discountTotal / currencyConversionFactor, 0)
      : getAndCheckIfOneTrue(favItem?.discountTotal, 0);
    const { categoryId: catId = 'NA', categoryName: catName = 'NA' } = productMapById?.[i?.id] ?? {};
    itemsArray.push({
      item_name: i?.name,
      item_id: i?.id,
      price: price,
      item_category: catName,
      item_list_name: ACCOUNT_FAV_PAGE,
      item_list_id: catId,
      index: idx,
      quantity: i?.quantity,
      coupon: getAndCheckIfOneTrue(favItem?.couponCode, 'NA'),
      discount: discountTotal,
      currency: ANALYTICS_SHARED_CONSTANTS.INR,
    });
  });
  ViewFavMenu(itemsArray);
};
//onClick of Reorder button for favourite Orders
const analyticHandler = userParams => {
  !userParams?.localized && localisationStartAnalytics();
  localStorage.setItem(CURRENT_FAV_MENU, ACCOUNT_FAVORDERS);
};
const FavouriteOrderComponent = props => {
  const { isMobile, updateMenu, currentMenu } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const { LOAD_MORE, ADD_ITEM_TO_CART_TEXT } = ORDRE_HISTORY;
  const { RESET_MODGROUP_IDS_UPDATE } = MENU_PDP_PAGE_CONSTANTS;
  const { MINI_PDP_DATA, FROMFLAGPLP, EDIT_CLICKED, ADD_TO_CART_CLICK } = START_ORDER_CONSTANTS;
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [editItemId, setEditItemId] = useState('');
  const [limitSize, setLimitSize] = useState(9);
  const [updatedOccasionName, setUpdatedOccasionName] = useState('');
  const [occasionName, setOccasionName] = useState('');
  const favoriteOrderData = useSelector(data => data.profileReducer?.favouriteOrders || []);
  const favouriteItems = useSelector(data => data.profileReducer?.favouriteItems || []);
  const { id: customerId, phone: phoneNumber } = useSelector(data =>
    getValueOrDefaultObject(data.profileReducer?.basic),
  );
  const { tenantId, currencyConversionFactor } = useSelector(data => data.tenantReducer || {});
  const tenantReducer = useSelector(data => data.tenantReducer);
  const cartReducer = useSelector(data => data.cartReducer);
  const { flatResponse: { productMapById = {}, itemMapById = {}, categoryMapById = {} } = {} } = getEmptyObjectforNull(
    useSelector(({ menuReducer }) => menuReducer),
  );
  const currentItemDetails = useSelector(({ menuReducer }) => menuReducer?.currentItemDetails);
  const userParams = useSelector(data => data.appStateReducer.userStatus);
  const [localizationFlow, setLocalizationFlow] = useState(false);
  const {
    ORDER_HISTORY_TAG,
    VIEW_ORDER_HISTORY_BTN,
    MY_OCCASSION_TEXT,
    MY_OCCASSION_UNAVAILABLE_TITLE,
    DELETE_OCCASSION_TEXT,
    REORDER_TEXT,
    MY_FAVOURITE_MENU_TITLE_TEXT,
    MY_FAVOURITE_NO_ITEMS_TEXT,
    MY_FAVOURITE_BROWSE_MENU,
    MY_FAV_MENU,
    UNFAVOURITE_ITEM_MESSAGE,
  } = ORDER_HISTORY;
  const cartData = getEmptyObjectforNull(get(cartReducer, 'cartData', {}));
  const [reorderModalOpen, setReorderModalOpen] = useState(false);
  const [isQuickReorderModalOpen, setQuickReorderModalOpen] = useState(false);
  const [storeInfo, setStoreInfo] = useState({});
  const [selectedOrder, setSelectedOrder] = useState({});

  const onClickHandler = (e, item) => {
    const accordian = e.target?.parentElement?.parentElement?.parentElement;
    accordian?.classList.contains('account-accordian-open')
      ? accordian?.classList.remove('account-accordian-open')
      : accordian?.classList.add('account-accordian-open');
    const favItem = favoriteOrderData?.find(product => item?.id === product?.id);
    setViewFavOrderMenuAnalyticsData(favItem, productMapById, currencyConversionFactor);
  };

  const getPrice = price => {
    return price / currencyConversionFactor;
  };

  const dispositionNewFavOrder = isEmptyEvery(userOrderState.dispositionNew)
    ? JSON.parse(localStorage.getItem('dispositionNew'))
    : userOrderState.dispositionNew;
  const params = useMemo(() => {
    return {
      tenantReducer: isEmptyObject(tenantReducer) ? tenantReducer : JSON.parse(localStorage.getItem('tenantReducer')),
      storeInfo: dispositionNewFavOrder ? dispositionNewFavOrder.store : {},
      dispositionType:
        dispositionNewFavOrder?.type
          ? getDispositionTypeOnAPIFormat(dispositionNewFavOrder.type)
          : getDispositionTypeOnAPIFormat(tenantReducer.authoredContent?.defaultdisposition),
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispositionNewFavOrder, tenantReducer, userOrderState]);

  const catalogs =
    (params?.storeInfo?.summary?.menu?.catalogs?.length && params?.storeInfo?.summary?.menu?.catalogs[0]) ||
    getValueOrEmptyString(tenantReducer?.genericMenuName);

  const addItemToCart = (tenantIds, id, basketId, categoryDetails) => {
    const { categoryId, categoryName, categoryUrl } = categoryDetails;
    dispatch(
      addItemToCartAction(
        {
          params: { basketId },
          tenantId: tenantIds,
        },
        [{ Id: id, categoryId: categoryId, quantity: 1, modGrps: [], categoryName, categoryUrl }],
      ),
    );
  };

  // Functionality to add to cart
  const addToCartFunction = (event, item, productSelectedProps) => {
    event?.stopPropagation();
    const { categoryId: productCatId = '' } = productMapById?.[item.id] ?? {};
    const { id: catId = '', name: catName = '', url: catUrl = '' } = categoryMapById?.[productCatId] ?? {};
    const categoryDetails = {
      categoryId: catId,
      categoryName: catName,
      categoryUrl: catUrl,
    };
    const { id, isCustomized } = item;
    if (userParams.localized) {
      if (isCustomized) {
        userOrderStateDispatch({
          type: MINI_PDP_DATA,
          value: { id: id, flag: FROMFLAGPLP, foodLineId: '' },
        });
        //Customization Modal
        userOrderStateDispatch({ type: RESET_MODGROUP_IDS_UPDATE });
        userOrderStateDispatch({
          type: EDIT_CLICKED,
          value: { cartEditClicked: true },
        });
        dispatch(
          fetchItemDetailsAction({
            tenantId: tenantId,
            catalogName: catalogs,
            itemId: id,
          }),
        );
      } else {
        addItemToCart(tenantId, id, cartReducer?.cartData?.id, categoryDetails);
        dispatch(setUserLastActiveTime(new Date()));
        addFavouriteItemToCart({
          item_name: getValueOrDefaultAlternativeObject(item.name, 'NA'),
          item_id: getValueOrDefaultAlternativeObject(item.id, 'NA'),
          item_category: catName,
          price: getValueOrDefaultAlternativeObject(item.price, 'NA'),
          item_variant: 'NA',
          item_list_name: catName,
          item_list_id: catId,
          index: 1,
          quantity: getValueOrDefaultAlternativeObject(item.quantity || 1),
        });
      }
    } else {
      setLocalizationFlow(true);
      userOrderStateDispatch({
        type: ADD_TO_CART_CLICK,
        value: {
          addToCart: true,
          productItemId: id,
          categoryId: catId,
          oldProduct: productSelectedProps,
          customizable: isCustomized,
          catalogs: catalogs,
          fromPdpPage: false,
        },
      });
    }
  };

  const addItemToFavourite = (tenant_id, data, customer_id) => {
    dispatch(
      addItemToFavouriteAction(
        {
          tenantId:tenant_id,
          customerId:customer_id,
        },
        data,
      ),
    );
  };

  const addItemToFavouriteFunction = (tenant_id, itemDetails, availability = [], customerinfo) => {
    const payload = {
      mdmId: itemDetails.mdmId,
      id: itemDetails.id,
      name: itemDetails.name,
      imageName: itemDetails.imageName,
      description: itemDetails.description,
      quantity: 1,
      isCustomized: itemDetails.customizable,
      price: itemDetails.priceWithTax / currencyConversionFactor,
      additionalProperties: itemDetails.additionalProperties,
    };
    addItemToFavourite(tenant_id, payload, customerinfo);
  };

  const addItemToUnFavouriteFunction = (tenant_id, customer_id, itemId) => {
    dispatch(
      addItemToUnFavouriteAction({
        tenantId:tenant_id,
        customerId:customer_id,
        itemId,
      }),
    );
    let imageTemplate = <ImageComponent srcFile={CartNotificationSuccessImage} />;
    setTimeout(() => {
      toastifyFnWithImage(translateWithI18Next(UNFAVOURITE_ITEM_MESSAGE), imageTemplate);
    }, 2000);
    setTimeout(() => {
      toast.dismiss();
    }, 4000);
  };

  const deleteTheOccassion = async (tenant_id, customer_id, itemId) => {
    await dispatch(
      deleteFavOrder({
        tenant_id,
        customer_id,
        itemId,
      }),
    );
  };

  const checkProductAvailability = id => {
    const scheduledTime = getCurrentDateTimeInUnix();
    const product = getEmptyObjectforNull(itemMapById?.[id]);
    const startTime = product?.availability?.[0]?.availableHours.startTime.time;
    const endTime = product?.availability?.[0]?.availableHours.endTime.time;
    return dateIsBetween(scheduledTime, startTime, endTime);
  };

  const availableProductPrice = id => {
    const isProductAvailable = checkProductAvailability(id);
    if (isProductAvailable) {
      const product = getEmptyObjectforNull(itemMapById?.[id]);
      return product?.availability?.[0]?.price;
    }
    return 0;
  };

  const onEditOccasion = (id, occasion) => {
    if (id) {
      setEditItemId(id);
      setOpenEditModal(true);
      setUpdatedOccasionName(occasion);
      setOccasionName(occasion);
    }
  };

  const handleCloseEditOccasion = () => {
    setEditItemId('');
    setOpenEditModal(false);
  };

  const handleClearEditInput = () => {
    setUpdatedOccasionName('');
  };
  const UpdateOccasionName = () => {
    const { phoneNumber } = AuthManager.getInstance();
    const payload = { tenantId, customerId, phoneNumber };
    const postBody = { orderId: editItemId, name: updatedOccasionName };
    dispatch(addFavOrder(payload, postBody));
    setEditItemId('');
  };

  const onChangeOccasionName = event => {
    setUpdatedOccasionName(event.target.value);
  };

  const gotoMenu = () => {
    history.push({
      pathname: '/menu',
    });
  };

  // Function handle pagination using load more
  const loadmore = useCallback(() => {
    let totalCount = 0;
    totalCount = limitSize + 9;
    if (totalCount > favouriteItems.length) {
      const updateCount = favouriteItems.length - limitSize;
      setLimitSize(limitSize + updateCount);
    } else {
      setLimitSize(totalCount);
    }
  }, [limitSize, favouriteItems]);

  useEffect(() => {
    if (favouriteItems.length < limitSize) {
      setLimitSize(favouriteItems.length);
    }
  }, [dispatch, favouriteItems, limitSize]);

  useEffect(() => {
    fetchCustomerInfo(tenantId, customerId, phoneNumber, dispatch);
  }, [dispatch, tenantId, customerId, phoneNumber]);

  useEffect(() => {
    if (
      currentItemDetails &&
      userOrderState.minipdpData.itemId === currentItemDetails.id &&
      userOrderState.cartEditClicked
    ) {
      //to set flag in cartReducer
      dispatch(
        showCustomizationModalAction({
          showProductListingModal: true,
          categorySelected: '',
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentItemDetails, userOrderState.minipdpData.itemId, userOrderState.cartEditClicked]);

  useEffect(() => {
    if (cartReducer?.isItemAdded) {
      toast.dark(
        <div className='img-text-div'>
          <ImageComponent srcFile={tickWhiteToast} />{' '}
          <span className='text'>{translateWithI18Next(ADD_ITEM_TO_CART_TEXT)}</span>
        </div>,
        {
          className: 'coupon-toast-position',
          bodyClassName: 'success-coupon-toast',
          hideProgressBar: true,
          position: toast.POSITION.BOTTOM_CENTER,
        },
      );
      setTimeout(() => {
        toast.dismiss();
      }, 3000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartReducer?.isItemAdded]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    setLocalizationFlow(false);
  });
  useEffect(() => {
    if (currentMenu === MY_FAV_MENU) {
      if (favouriteItems?.length) {
        setViewFavOrderMenuAnalyticsData(favouriteItems, productMapById, currencyConversionFactor);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentMenu]);
  const { foodLines = [] } = cartData;
  const successCallback = () => {
    if (foodLines.length > 0) {
      setReorderModalOpen(true);
    } else {
      dispatch(resetBasketAction());
      setQuickReorderModalOpen(true);
    }
  };

  const reorderBtnHandler = orderItem => {
    const store = get(orderItem, 'store', {});
    const service = get(orderItem, 'service', '');
    const storeId = get(store, 'storeId', '');
    const data = [
      {
        storeId,
        channel: ChannelManager.channel,
        service,
      },
    ];
    dispatch(
      getReorderStoreStatus(data, tenantId, response => {
        const storeDetails = first(get(response, 'response', {}), {});
        const { id: orderId } = orderItem;
        setStoreInfo(storeDetails);
        dispatch(getPostOrderAccepted({ tenantId, orderId, customerId }, successCallback));
      }),
    );
    setSelectedOrder(orderItem);
    /* setting true value to reorderClick, to avoid the toast onclick of reorder button */
    sessionStorage.setItem('reorderClick', true);
  };

  return (
    <div className='account-order-desktop'>
      <div className='account-settings-header-mobile'>
        <img
          className='backArrow-account-setting'
          data-testid='fav-menu-backArrow'
          onClick={() => updateMenu('')}
          src={SingleArrowback}
          alt='back button'
        />
        <span className='account-setting-text-header'>{translateWithI18Next(MY_FAV_MENU)}</span>
      </div>
      <div className='page-header page-header-favourite-occasion'>
        <span className='page-heading'>
          {translateWithI18Next(MY_OCCASSION_TEXT)}{' '}
          {favoriteOrderData.length > 0 ? `(${favoriteOrderData.length})` : ''}
        </span>
      </div>
      {favoriteOrderData.length === 0 && (
        <div className='no-occasion-container'>
          <p>{translateWithI18Next(MY_OCCASSION_UNAVAILABLE_TITLE)}</p>
          <ButtonComp
            data-testid='menupageBtn-id'
            className='button whiteButton blackBorder store-card-btn browse-menu-btn'
            onClick={() => updateMenu(ORDER_HISTORY_TAG)}
          >
            {translateWithI18Next(VIEW_ORDER_HISTORY_BTN)}
          </ButtonComp>
        </div>
      )}
      {favoriteOrderData?.map((item, index) => {
        return (
          <div className='sub-section sub-section-favourite'>
            <section>
              <section className='account-accordian'>
                <OrderDetailSection
                  title={item.name}
                  occassionTime={
                    isMobile
                      ? `${getFormatFromUnix(item.fulfillmentDateTime, 'll')}`
                      : `${getFormatFromUnix(item.fulfillmentDateTime, 'll')} at ${getFormatFromUnix(
                          item.fulfillmentDateTime,
                          'hh:mm a',
                        )}`
                  }
                  onClickHandler={event => onClickHandler(event, item)}
                  onEditOccasionName={onEditOccasion}
                  itemId={item.id}
                  itemName={item.name}
                  data-testid='order-details'
                >
                  <OccassionItemsComponent
                    occassionOrder={item}
                    checkProductAvailabity={checkProductAvailability}
                    addItemToFavourite={addItemToFavouriteFunction}
                    additemToUnfavourite={addItemToUnFavouriteFunction}
                    availableProductPrice={availableProductPrice}
                    getPrice={getPrice}
                    data-testid='occasion-component'
                  />
                  <section className='fav-menu-event'>
                    <div className='global-accordian-header-container mobile-accordian-reorder-container'>
                      <span className='global-accordian-header mobile-accordian-header'>
                        <span
                          className='order-receipt-option'
                          data-testid='delete-occassion'
                          onClick={() => deleteTheOccassion(tenantId, customerId, item.id)}
                        >
                          {translateWithI18Next(DELETE_OCCASSION_TEXT)}
                        </span>
                      </span>
                      <div className='global-accordian-right'>
                        {
                          <ButtonComp
                            className='button re-order-btn redButton'
                            aria-label={''}
                            type='submit'
                            onClickHandler={() => {
                              analyticHandler(userParams);
                              reorderBtnHandler(item);
                            }}
                            data-testid='re-order-btn'
                          >
                            <img src={ReorderIcon} className='account-icon' alt='Account Icon'/>
                            <span>{translateWithI18Next(REORDER_TEXT)}</span>
                          </ButtonComp>
                        }
                      </div>
                    </div>
                  </section>
                </OrderDetailSection>
              </section>
              <EditOccasionModalComponent
                isOpen={item.id === editItemId}
                handleClose={handleCloseEditOccasion}
                occasionName={updatedOccasionName}
                onSaveOccassion={UpdateOccasionName}
                onChangeOccasionName={onChangeOccasionName}
                occasionNameResponse={occasionName}
                handleClearEditInput={handleClearEditInput}
              />
            </section>
          </div>
        );
      })}
      <div className='page-header page-header-favourite'>
        <span className='page-heading'>
          {translateWithI18Next(MY_FAVOURITE_MENU_TITLE_TEXT)}{' '}
          {favouriteItems.length > 0 ? `(${favouriteItems.length})` : ''}
        </span>
      </div>
      {cartReducer?.showProductListingModal && <ProductListingModalOptions />}
      <div className='favorite-items-container'>
        {favouriteItems.length === 0 && (
          <div className='no-occasion-container'>
            <p>{translateWithI18Next(MY_FAVOURITE_NO_ITEMS_TEXT)}</p>
            <ButtonComp
              data-testid='menupageBtn-id'
              className='button whiteButton blackBorder store-card-btn browse-menu-btn'
              onClick={gotoMenu}
            >
              {translateWithI18Next(MY_FAVOURITE_BROWSE_MENU)}
            </ButtonComp>
          </div>
        )}
        <FavouriteMenuComponent
          limitSize={limitSize}
          checkProductAvailabity={checkProductAvailability}
          addItemToUnFavouriteFunction={addItemToUnFavouriteFunction}
          addToCartFunction={addToCartFunction}
          availableProductPrice={availableProductPrice}
          getPrice={getPrice}
          data-testid='favourite-menu'
          userParams={userParams}
        />
      </div>
      {favouriteItems.length > 9 && (
        <div className='load-more-button-container'>
          <ButtonComp
            className='button whiteButton blackBorder store-card-btn browse-menu-btn'
            data-testid='load-more-favourite-items'
            onClick={loadmore}
          >
            {translateWithI18Next(LOAD_MORE)}
          </ButtonComp>
          <div className='load-more-text'>
            {translateWithI18Next(`Viewed ${limitSize} of ${favouriteItems.length}`)}
          </div>
        </div>
      )}
      {localizationFlow && <UserLocalization />}
      {(reorderModalOpen || isQuickReorderModalOpen) && (
        <ReorderComponent
          storeInfo={storeInfo}
          currentOrderInfo={selectedOrder}
          reorderModalOpen={reorderModalOpen}
          setReorderModalOpen={setReorderModalOpen}
          isQuickReorderModalOpen={isQuickReorderModalOpen}
          setQuickReorderModalOpen={setQuickReorderModalOpen}
        />
      )}
    </div>
  );
};

export default FavouriteOrderComponent;
